import React from "react";
import "./CeoCircle.css";

/**
 * Initials shown when an awardee has no photo: first letter of the first and last word.
 * "Alex Rivera" -> "AR", "Julia Grace Cansino" -> "JC", "Madonna" -> "M".
 */
export const initials = (name) => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  const first = parts[0][0];
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
};

/**
 * One CEO Circle of Excellence poster (pure presentational, no redux).
 * Props:
 *   awardee : {name, year, job_title, citation, photo_url, photo_pos_y, photo_zoom}
 *   teaser  : when true the poster is the "Who will it be?" placeholder for awardee.year
 *   label   : optional accessible name override (the form's live preview uses it)
 * All user-supplied strings are rendered as React text, never as markup.
 */
const CeoCirclePoster = ({ awardee, teaser, label }) => {
  const a = awardee || {};
  const year = a.year != null ? String(a.year) : "—";

  const name = teaser ? "Who will it be?" : a.name || "Employee name";
  const title = teaser ? "Revealing soon" : a.job_title || "Job title";
  const citation = teaser
    ? "The " + year + " CEO Circle of Excellence honouree will be announced soon. Stay tuned."
    : a.citation || "Citation appears here";

  const ariaLabel =
    label ||
    (teaser
      ? "CEO Circle of Excellence " + year + ": honouree to be revealed"
      : name + ", CEO Circle of Excellence " + year);

  let photo;
  if (teaser) {
    photo = <span className="p-q">?</span>;
  } else if (a.photo_url) {
    const posY = a.photo_pos_y == null ? 30 : a.photo_pos_y;
    const zoom = (a.photo_zoom || 100) / 100;
    photo = (
      <img
        alt=""
        src={a.photo_url}
        style={{ objectPosition: "50% " + posY + "%", transform: "scale(" + zoom + ")" }}
      />
    );
  } else {
    photo = <span className="p-initials">{initials(a.name)}</span>;
  }

  return (
    <div className={"poster" + (teaser ? " is-teaser" : "")} role="img" aria-label={ariaLabel}>
      <div className="p-top">
        <span className="p-org">EASTVANTAGE RECOGNITION</span>
        <span className="p-year">{year}</span>
      </div>
      <div className="p-badge">CEO CIRCLE OF EXCELLENCE</div>
      <div className="p-ring">
        <div className="p-photo">{photo}</div>
      </div>
      <div className="p-name">{name}</div>
      <div className="p-title">{title}</div>
      <div className="p-cite">{citation}</div>
      <div className="p-foot">
        <span className="l">
          <span className="brand">Eastvantage</span> &nbsp;•&nbsp; Excellence Awards
        </span>
        <span className="r">HIGH-IMPACT • SCALABLE • VALUE-DRIVEN</span>
      </div>
    </div>
  );
};

export default CeoCirclePoster;
